export enum ROLE_TYPE_ENUM {
  SUPER_ADMIN = 9999,
  ADMIN = 1,
  MOBILE_ADMIN = 8888,
}
